export const UserActionConst = {
  FETCH_PENDING_USERS_REQUEST: "FETCH_PENDING_USERS_REQUEST",
  FETCH_PENDING_USERS_SUCC: "FETCH_PENDING_USERS_SUCC",
  FETCH_PENDING_USERS_FAIL: "FETCH_PENDING_USERS_FAIL",
  
  FETCH_ALL_USERS_REQUEST: "FETCH_ALL_USERS_REQUEST",
  FETCH_ALL_USERS_SUCC: "FETCH_ALL_USERS_SUCC",
  FETCH_ALL_USERS_FAIL: "FETCH_ALL_USERS_FAIL",
  
  FETCH_USER_DETAIL_REQUEST: "FETCH_USER_DETAIL_REQUEST",
  FETCH_USER_DETAIL_SUCC: "FETCH_USER_DETAIL_SUCC",
  FETCH_USER_DETAIL_FAIL: "FETCH_USER_DETAIL_FAIL",
  
  APPROVE_USER_REQUEST: "APPROVE_USER_REQUEST",
  APPROVE_USER_SUCC: "APPROVE_USER_SUCC",
  APPROVE_USER_FAIL: "APPROVE_USER_FAIL",
  
  UPDATE_USER_REQUEST: "UPDATE_USER_REQUEST",
  UPDATE_USER_SUCC: "UPDATE_USER_SUCC",
  UPDATE_USER_FAIL: "UPDATE_USER_FAIL",
  
  CLEAR_UPDATE_STATE: "CLEAR_UPDATE_STATE",
};

